import { render, staticRenderFns } from "./partnerOrder.vue?vue&type=template&id=d47482bc&scoped=true&"
import script from "./partnerOrder.vue?vue&type=script&lang=js&"
export * from "./partnerOrder.vue?vue&type=script&lang=js&"
import style0 from "./partnerOrder.vue?vue&type=style&index=0&id=d47482bc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d47482bc",
  null
  
)

export default component.exports